import React from 'react'
import { ConditionalWrapperProps } from './ConditionalWrapper.d'

const ConditionalWrapper = ({
  condition,
  wrapper,
  children
}: ConditionalWrapperProps) => {
  const wrapperElement = condition ? wrapper(<>{children}</>) : <>{children}</>

  return wrapperElement
}

export default ConditionalWrapper
